import { render, staticRenderFns } from "./ascReportSection.vue?vue&type=template&id=3471edec&scoped=true&"
import script from "./ascReportSection.vue?vue&type=script&lang=js&"
export * from "./ascReportSection.vue?vue&type=script&lang=js&"
import style0 from "./ascReportSection.vue?vue&type=style&index=0&id=3471edec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3471edec",
  null
  
)

export default component.exports